module.exports = __webpack_public_path__ + "img/5-certifications-ml_cut.png";